<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-08-30 11:32:48
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-08-30 17:13:55
-->
<template>
  <div>
   
    <div class="search-box">
      <div class="toolbox"></div>
      <div class="result-list">
        <div
          class="result-item"
          v-for="item in list"
          :key="item.id"
          @click="
            () => $router.push({ path: '/enterpriseDetail', query: { id: item.id } })
          "
        >
          <div class="avatar">
            <img :src="'/app/common/attachment?id=' + item.agencyzLogo" />
          </div>
          <div class="result-info">
            <div class="result-info-title">{{ item.name }}</div>
            <div class="result-info-content">
              <span style="color: #999">联系电话：</span
              ><span style="color: #ce1b14">{{ item.enterprisePhone }}</span>
              <span style="color: #999; margin-left: 20px">机构地址:</span
              ><span>{{ item.address }}</span>
            </div>
            <div class="result-info-link">企业邮箱：{{ item.enterpriseEmail }}</div>
          </div>
          <div class="result-time">
            <span>入驻时间:{{ item.createTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import request from "../util/request";
export default {
  name: "search",
  
  data() {
    return {
      data: new Array(5).fill({ title: "213" }),
      list: [],
    };
  },
  mounted() {
    this.queryList();
  },
  methods: {
    queryList() {
      request({
        url: "/client/common/enterprise/search",
        method: "get",
        params: { type: "ORG_OWNER" },
      }).then((res) => {
        if (res.code == "200") {
          this.list = res.data.records;
        }
      });
    },
  },
};
</script>
<style lang="less">
.result-list {
  background: #fff;
  .result-item { padding:20px;
    align-items: center;
    display: flex;
    height: 200px;
    border-bottom: 2px solid #f2f2f2;
    .avatar {
      width: 220px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .result-info {
      width: 600px;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .result-info-title {
        color: #ce1b14;
        font-size: 18px;
        font-weight: bold;
      }
      .result-info-link {
        color: #ce1b14;
      }
    }
    .result-time {
      color: #999;
    }
  }
}
</style>
